import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';

import {
  ArrowNavigationButton,
  ArrowNavigationContainer,
} from './ArrowNavigation.styled';

type Props = {
  nextPage: () => void;
  prevPage: () => void;
  current: number;
  total: number;
};

export function ArrowNavigation({ nextPage, prevPage, current, total }: Props) {
  const { i18n } = useI18n();

  const title = {
    prev: i18n('Previous page'),
    next: i18n('Next page'),
  };

  const prevDisabled = current <= 0;
  const nextDisabled = current >= total - 1;
  return (
    <ArrowNavigationContainer>
      <ArrowNavigationButton
        type="button"
        onClick={prevPage}
        aria-label={title.prev}
        title={title.prev}
        disabled={prevDisabled}
        data-qa-id="carousel-left-button"
      >
        <span style={{ marginLeft: -2 }}>
          <Icon name="chevron-left" size={24} />
        </span>
      </ArrowNavigationButton>

      <ArrowNavigationButton
        type="button"
        onClick={nextPage}
        aria-label={title.next}
        title={title.next}
        disabled={nextDisabled}
        data-qa-id="carousel-right-button"
      >
        <span style={{ marginRight: -2 }}>
          <Icon name="chevron-right" size={24} />
        </span>
      </ArrowNavigationButton>
    </ArrowNavigationContainer>
  );
}
